import React, { FC } from 'react'

import { getMobileNavEvent, IconLink, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconFR: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <IconLink
    analytics={getMobileNavEvent('trustedshops', variant)}
    href="https://www.trustedshops.fr/evaluation/info_X486286508E1E6A83AF3E43C51929EA24.html"
    rel="noopener noreferrer"
    target="_blank"
    variant={variant}
  >
    <img alt="" src="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt3b30b87a9b34b1e6/trusted-shops-logo.png" />
  </IconLink>
)
